export const TASK_USER_MAP = {
  ASSIGNOR: 0,
  ASSIGNEE: 1,
  SUPPORTER: 2,
  WATCHER: 3,
};
